export default __webpack_public_path__ + "c12b389fc1d01692901f782b33cf116d.png";